"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubsocialApi = void 0;
const utils_1 = require("./flatteners/utils");
const basic_1 = require("./basic");
const utils_2 = require("@subsocial/utils");
const flatteners_1 = require("./flatteners");
const connections_1 = require("../connections");
class SubsocialApi {
    constructor(props) {
        this._base = new basic_1.BasicSubsocialApi(props);
    }
    static create(_a) {
        var { substrateNodeUrl } = _a, props = __rest(_a, ["substrateNodeUrl"]);
        return __awaiter(this, void 0, void 0, function* () {
            const substrateApi = yield (0, connections_1.getSubstrateApi)(substrateNodeUrl);
            return new SubsocialApi(Object.assign({ substrateApi }, props));
        });
    }
    /** @deprecated */
    get subsocial() {
        return this._base;
    }
    get base() {
        return this._base;
    }
    /** Accessors for private field {@link _base.substrate}*/
    get blockchain() {
        return this._base.substrate;
    }
    /** Accessors for private field {@link _base.ipfs}*/
    get ipfs() {
        return this._base.ipfs;
    }
    /** Accessors for private field {@link _base.substrate.api}*/
    get substrateApi() {
        return this._base.substrate.api;
    }
    findSpaceStructs(ids, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const structs = yield this.base.substrate.findSpaces(Object.assign({ ids: (0, utils_2.idsToBns)(ids) }, filters));
            return (0, flatteners_1.flattenSpaceStructs)(structs);
        });
    }
    findPostStructs(ids, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const structs = yield this.base.substrate.findPosts(Object.assign({ ids: (0, utils_2.idsToBns)(ids) }, filters));
            return (0, flatteners_1.flattenPostStructs)(structs);
        });
    }
    findSpaceStruct(id, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_2.getFirstOrUndefined)(yield this.findSpaceStructs([id], filters));
        });
    }
    findPostStruct(id, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_2.getFirstOrUndefined)(yield this.findPostStructs([id], filters));
        });
    }
    findSpace(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const old = yield this.base.findSpace(query);
            return !old ? old : (0, utils_1.convertToNewSpaceData)(old);
        });
    }
    findPublicSpaces(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_1.convertToNewSpaceDataArray)(yield this.base.findPublicSpaces((0, utils_2.idsToBns)(ids)));
        });
    }
    findUnlistedSpaces(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_1.convertToNewSpaceDataArray)(yield this.base.findUnlistedSpaces((0, utils_2.idsToBns)(ids)));
        });
    }
    findPost(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const old = yield this.base.findPost(query);
            return !old ? old : (0, utils_1.convertToNewPostData)(old);
        });
    }
    findPublicPosts(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_1.convertToNewPostDataArray)(yield this.base.findPublicPosts((0, utils_2.idsToBns)(ids)));
        });
    }
    findPostWithSomeDetails(query) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_1.convertToNewPostWithSomeDetails)(yield this.base.findPostWithSomeDetails(query));
        });
    }
    findPostWithAllDetails(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_1.convertToNewPostWithAllDetails)(yield this.base.findPostWithAllDetails((0, utils_2.idToBn)(id)));
        });
    }
    findPostsWithAllDetails(query) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_1.convertToNewPostWithAllDetailsArray)(yield this.base.findPostsWithAllDetails(query));
        });
    }
    findPublicPostsWithSomeDetails(query) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_1.convertToNewPostWithSomeDetailsArray)(yield this.base.findPublicPostsWithSomeDetails(query));
        });
    }
    findPublicPostsWithAllDetails(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_1.convertToNewPostWithAllDetailsArray)(yield this.base.findPublicPostsWithAllDetails((0, utils_2.idsToBns)(ids)));
        });
    }
    findUnlistedPostsWithAllDetails(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_1.convertToNewPostWithAllDetailsArray)(yield this.base.findUnlistedPostsWithAllDetails((0, utils_2.idsToBns)(ids)));
        });
    }
    //------------------------------------------------
    // Domains
    findDomains(domainNames) {
        return __awaiter(this, void 0, void 0, function* () {
            const structs = yield this.blockchain.registeredDomains(domainNames);
            return (0, flatteners_1.flattenDomainStructs)(structs);
        });
    }
    findDomain(domainName) {
        return __awaiter(this, void 0, void 0, function* () {
            return (0, utils_2.getFirstOrUndefined)(yield this.findDomains([domainName]));
        });
    }
}
exports.SubsocialApi = SubsocialApi;
